import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
          change: {
              variant: 'variantSelect',
          }
        };

        this.variantData = null;
        this.currentVariant = null;
    }

    init() {
      
    }

    variantSelect(e) {
      this.updateMasterId(e.currentTarget);
      this.updateUrl();
      this.updateVariantTitle();
      this.updateVariantGallery();
    }

    updateMasterId(variant) {
      const title = this.getData('title', variant);
      const id = variant.getAttribute('id');
      const variantData = this.getVariantData().find((variant) => {
        return variant.id == id;
      });

      this.productData = JSON.parse(this.getData('data'));

      this.currentVariant = {}
      this.currentVariant.id = id;
      this.currentVariant.title = title;
      this.currentVariant.data = variantData;
      this.currentVariant.id = id;
      this.currentVariant.handle = this.productData.handle;
      this.currentVariant.images = this.productData.media.filter((image) => {
        if(image.alt) {
          return image.alt.includes(title)
        }
        
        return false
      });

      
    }

    updateUrl() {
      window.history.replaceState({ }, '', `${this.currentVariant.handle}?variant=${this.currentVariant.id}`);
    }

    updateVariantTitle() {
      this.$("variant-title")[0].innerHTML = this.currentVariant.data.title;
    }

    updateVariantGallery() {
      let imagesContent = "";
      let thumbsContent = "";

      this.currentVariant.images.forEach((image,i) => {
        imagesContent += `<div class="keen-slider__slide c-lazy">
            <img
              data-lazyload
              class="c-product-gallery_image"
              sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              data-src="${image.src}"
              alt="${image.alt}">
          </div>`

        thumbsContent += `<li
          class="c-product-gallery_thumbnail c-lazy"
          data-carousel="thumbnail"
          data-index="${i}">
          <img
            data-lazyload
            class="c-product-gallery_thumbnailimage"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            data-src="${image.src}"
            alt="${image.alt}">
        </div>`

      })

      this.call('addNewImages', { images: imagesContent, thumbs: thumbsContent}, 'Carousel', `productgallery${this.productData.id}`);
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.el.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
}
